import React, { useState, useEffect }  from 'react'
import axios from 'axios'
import { PiMicrophoneFill,PiMicrophoneSlashFill,PiSpeakerSimpleHighFill,PiSpeakerSimpleSlashFill } from 'react-icons/pi'
import { FaMicrophoneSlash } from 'react-icons/fa'
import { useSearchParams } from 'react-router-dom'
import { IoIosPlay } from 'react-icons/io'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`

export default function LlmSpeechText(){
  const [loadingMsg, setLoadingMsg]= useState(false)
  const [microphone, setMicrophone] = useState(false)
  const [speaker, setSpeaker] = useState(false)
  const [script, setScript]= useState([{speaker: "A", msg: "Test"}, {speaker: "B", msg: "Success."}, {speaker: "A", msg: "What is AI"}, {speaker: "B", msg: "Artificial Intelligence is a technology that enables machines to perform tasks that typically require human intelligence."}, {speaker: "A", msg: "What is NFL"}, {speaker: "B", msg: "National Football League, a professional American football league."}])
  const [userInput, setUserInput] = useState({'user':''})
  const onChange2Input = ({ currentTarget: x }) => { setUserInput({ ...userInput, [x.name]: x.value }) }
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
  var recognition = new SpeechRecognition()
  recognition.continuous = false
  recognition.lang = 'en-US'
  recognition.interimResults = false
  recognition.maxAlternatives = 1
  recognition.onresult = function(e) {
    setUserInput({user:e.results[0][0].transcript})
  }
  recognition.onaudiostart = () => {
    if(microphone){
      recognition.start()
    }
  }
  recognition.onspeechend = function() {
    recognition.stop()
    recognition.reset()
  }
  const onClick2Translate=async()=>{
      script.push({speaker:'A',msg:userInput.user})
      if(speaker){
        let utterance = new SpeechSynthesisUtterance(userInput.user)
        speechSynthesis.speak(utterance)
      }
      setLoadingMsg(true)
      try {
        const { data: res } = await axios.post(`${APIURL}/llm/speech-to-text`,userInput)
          setLoadingMsg(false)
          script.push({speaker:'B','msg':res['answer']})
          if(speaker){
            let utterance = new SpeechSynthesisUtterance(res['answer'])
            speechSynthesis.speak(utterance)
          }
      } catch (err) {
          console.log(err)
      }
  }
  const onClick2Microphone =()=>{
    if(microphone){
      setMicrophone(false)
    }else{
      setMicrophone(true)
      recognition.start()
    }
  }
  const onClick2Speaker =()=>{
    setSpeaker(!speaker)
  }
 return(
  <>
  <div className='text-left'>
  <div className='mt-[2px] flex'>
  <input className='pl-[2px] border border-gray-800 w-full md:w-80 mr-[2px]' nname='user' type='text' value={userInput.user} onChange={onChange2Input}/>
  <button className='bg-gray-800 hover:bg-gray-700 h-auto pl-[8px] pr-[8px] text-white text-[12px]' onClick={onClick2Translate} onKeyDown={(e) => onClick2Translate(e)}>Send</button>
  <div className='mt-auto mb-auto' onClick={onClick2Microphone}>{microphone?<PiMicrophoneFill />:<PiMicrophoneSlashFill />}</div><div className='mt-auto mb-auto' onClick={onClick2Speaker}>{speaker ?<PiSpeakerSimpleHighFill />:<PiSpeakerSimpleSlashFill/>}</div>
  </div>


    </div>
    <div className='text-left'>
    <>{script.map((x)=><>{x.speaker}: {x.msg}<br/></>)}</>{loadingMsg?<p className='flex text-xs'>Please wait for a moment<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>:''}
    </div>
  </>
 )
}